"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
var _exportNames = {
  Form: true,
  turnIntoField: true,
  removeFieldProps: true,
  getFieldProps: true
};
exports.getFieldProps = exports.removeFieldProps = exports.turnIntoField = exports.Form = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _Form = _interopRequireDefault(require("./Form"));

exports.Form = _Form.default;

var _Field = _interopRequireDefault(require("./Field"));

exports.turnIntoField = _Field.default;

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  exports[key] = _types[key];
});

var removeFieldProps = function removeFieldProps(props) {
  var name = props.name,
      defaultValue = props.defaultValue,
      label = props.label,
      required = props.required,
      onChange = props.onChange,
      validation = props.validation,
      type = props.type,
      errorMessages = props.errorMessages,
      dirty = props.dirty,
      fieldValue = props.fieldValue,
      errorMessage = props.errorMessage,
      values = props.values,
      errors = props.errors,
      setDirty = props.setDirty,
      isSubmitted = props.isSubmitted,
      submitForm = props.submitForm,
      formValid = props.formValid,
      other = (0, _objectWithoutPropertiesLoose2.default)(props, ["name", "defaultValue", "label", "required", "onChange", "validation", "type", "errorMessages", "dirty", "fieldValue", "errorMessage", "values", "errors", "setDirty", "isSubmitted", "submitForm", "formValid"]);
  return other;
};

exports.removeFieldProps = removeFieldProps;

var getFieldProps = function getFieldProps(props) {
  var name = props.name,
      defaultValue = props.defaultValue,
      label = props.label,
      required = props.required,
      onChange = props.onChange,
      validation = props.validation,
      type = props.type,
      errorMessages = props.errorMessages,
      dirty = props.dirty,
      fieldValue = props.fieldValue,
      errorMessage = props.errorMessage,
      values = props.values,
      errors = props.errors,
      setDirty = props.setDirty,
      isSubmitted = props.isSubmitted,
      submitForm = props.submitForm,
      formValid = props.formValid;
  return {
    name: name,
    defaultValue: defaultValue,
    label: label,
    required: required,
    onChange: onChange,
    validation: validation,
    type: type,
    errorMessages: errorMessages,
    dirty: dirty,
    fieldValue: fieldValue,
    errorMessage: errorMessage,
    values: values,
    errors: errors,
    setDirty: setDirty,
    isSubmitted: isSubmitted,
    submitForm: submitForm,
    formValid: formValid
  };
};

exports.getFieldProps = getFieldProps;